import { render, staticRenderFns } from "./AffiliateUrlTable.vue?vue&type=template&id=076769d8"
import script from "./AffiliateUrlTable.vue?vue&type=script&lang=js"
export * from "./AffiliateUrlTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports